import { FC, ReactNode } from 'react'
import { Card, Heading, Tag, Text, Stack } from '@instabox/consumer-web-ui'
import Link from 'next/link'
import { GetFaqsQuery, Unarray, getTranslation, Markdown } from '@instabox/consumer-web-shared'

type FAQDetailsProps = Unarray<GetFaqsQuery['faqs']> & {
  children?: ReactNode | undefined
}

const FAQDetails: FC<FAQDetailsProps> = ({
  question,
  answer,
  categories = [],
  translations,
  children,
}) => (
  <Card size="xl">
    <Heading as="h6" className="mb-4">
      {getTranslation('question', translations, question)}
    </Heading>
    <Stack>
      <Text as="div">
        <Markdown>{getTranslation('answer', translations, answer)}</Markdown>
      </Text>
      <Stack gap="sm" layout="horizontal">
        {categories.map(({ faq_categories_id: { id, name, slug, translations } }) => (
          <Tag key={id}>
            <Link href={`category/${slug}`} className="no-underline">
              {getTranslation('name', translations, name)}
            </Link>
          </Tag>
        ))}
      </Stack>
      {children}
    </Stack>
  </Card>
)

export default FAQDetails
